import { render, staticRenderFns } from "./examinationPaperList.vue?vue&type=template&id=03e4844f&scoped=true"
import script from "./examinationPaperList.vue?vue&type=script&lang=js"
export * from "./examinationPaperList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e4844f",
  null
  
)

export default component.exports